export default [
  {
    category: 'mod',
    type: 'MDF',
    author: '35439_Федотова',
    file: 'MDF/mod/35439_Федотова/exam_jan_2025_te6z71b5.jpg',
    source: 'local',
  },
  {
    category: 'mod',
    type: 'MDF',
    author: '35675_ОлійникД',
    file: 'MDF/mod/35675_ОлійникД/exam_jan_2025_by5njsfi.jpg',
    source: 'local',
  },
  {
    category: 'mod',
    type: 'MDF',
    author: '35784_Дегтярева',
    file: 'MDF/mod/35784_Дегтярева/exam_jan_2025_9fhqmjjh.jpg',
    source: 'local',
  },
  {
    category: 'mod',
    type: 'MDF',
    author: '35802_Маринеску',
    file: 'MDF/mod/35802_Маринеску/exam_jan_2025_yhyc7gaj.jpg',
    source: 'local',
  },
  {
    category: 'mod',
    type: 'MDF',
    author: '35826_Сварич',
    file: 'MDF/mod/35826_Сварич/exam_jan_2025_6ejlq5d9.jpg',
    source: 'local',
  },
  {
    category: 'mod',
    type: 'MDF',
    author: '36352_Гиз',
    file: 'MDF/mod/36352_Гиз/exam_jan_2025_1ugk02f6.jpg',
    source: 'local',
  },
  {
    category: 'mod',
    type: 'MDF',
    author: '36360_Колодийчук',
    file: 'MDF/mod/36360_Колодийчук/exam_jan_2025_vk7r1lzp.jpg',
    source: 'local',
  },
  {
    category: 'ext',
    type: 'MLR',
    author: '37141_Савинець',
    file: 'MLR/ext/37141_Савинець/exam_jan_2025_2aqsqzhm.jpg',
    source: 'local',
  },
  {
    category: 'ext',
    type: 'MLR',
    author: '37165_АндрусишинМ',
    file: 'MLR/ext/37165_АндрусишинМ/exam_jan_2025_uw8mry3l.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '37598_Саргсян',
    file: 'MLR/int/37598_Саргсян/exam_jan_2025_8wj54edo.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '37599_Іскрижицька',
    file: 'MLR/int/37599_Іскрижицька/exam_jan_2025_37t32l2v.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '37691_Застрожников',
    file: 'MLR/int/37691_Застрожников/exam_jan_2025_mr4o2752.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38259_Цимбаленко',
    file: 'MLR/int/38259_Цимбаленко/exam_jan_2025_1xfl3xmt.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38283_Сокулцан',
    file: 'MLR/int/38283_Сокулцан/exam_jan_2025_gw1hli6d.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38285_Каткова',
    file: 'MLR/int/38285_Каткова/exam_jan_2025_7q8ge67m.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38300_Устінов',
    file: 'MLR/int/38300_Устінов/exam_jan_2025_wcrf6um3.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38356_Жерліцина',
    file: 'MLR/int/38356_Жерліцина/exam_jan_2025_bz7ptcfb.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38373_КовальІ',
    file: 'MLR/int/38373_КовальІ/exam_jan_2025_7zm0bklu.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38381_Горбунова',
    file: 'MLR/int/38381_Горбунова/exam_jan_2025_krp4gf13.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38387_Крамарь',
    file: 'MLR/int/38387_Крамарь/exam_jan_2025_ai1fym41.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38396_Ярмак',
    file: 'MLR/int/38396_Ярмак/exam_jan_2025_2mc4qm8t.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38424_МельниченкоР',
    file: 'MLR/int/38424_МельниченкоР/exam_jan_2025_xbtb8f88.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38432_Войтушенко',
    file: 'MLR/int/38432_Войтушенко/exam_jan_2025_yiq0m2dr.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38446_Гнатів',
    file: 'MLR/int/38446_Гнатів/exam_jan_2025_c38j3pu2.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38448_Ремінний',
    file: 'MLR/int/38448_Ремінний/exam_jan_2025_7uk3hoe5.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38450_Сорокін',
    file: 'MLR/int/38450_Сорокін/exam_jan_2025_6wrm47l3.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38540_Неньчук',
    file: 'MLR/int/38540_Неньчук/exam_jan_2025_as96yjq9.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38543_Кочерга',
    file: 'MLR/int/38543_Кочерга/exam_jan_2025_131lvovl.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38555_Мудра',
    file: 'MLR/int/38555_Мудра/exam_jan_2025_4p4bv7qz.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38557_Іванський',
    file: 'MLR/int/38557_Іванський/exam_jan_2025_h9vx4ryq.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38569_Наконечний',
    file: 'MLR/int/38569_Наконечний/exam_jan_2025_m4g610mc.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38675_Кричківська',
    file: 'MLR/int/38675_Кричківська/exam_jan_2025_35gjtqre.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38705_Матат',
    file: 'MLR/int/38705_Матат/exam_jan_2025_yo7uq8wi.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38714_Шелковникова',
    file: 'MLR/int/38714_Шелковникова/exam_jan_2025_2l4bmjba.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38730_Рудченко',
    file: 'MLR/int/38730_Рудченко/exam_jan_2025_dptic2a5.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38784_ЛитвиненкоА',
    file: 'MLR/int/38784_ЛитвиненкоА/exam_jan_2025_5e82zxa8.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38787_ЛитвиненкоІ',
    file: 'MLR/int/38787_ЛитвиненкоІ/exam_jan_2025_j6yy5a2k.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38803_Гарбар',
    file: 'MLR/int/38803_Гарбар/exam_jan_2025_o5kjkyv4.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38820_Гребенюк',
    file: 'MLR/int/38820_Гребенюк/exam_jan_2025_0kluo37a.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '38851_Верхняцька',
    file: 'MLR/int/38851_Верхняцька/exam_jan_2025_koy154fg.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '39033_Тодоріко',
    file: 'MLR/int/39033_Тодоріко/exam_jan_2025_d6mkjmg8.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '39440_Кабанова',
    file: 'MLR/int/39440_Кабанова/exam_jan_2025_5yc5rk6c.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'MLR',
    author: '39664_Іванова',
    file: 'MLR/int/39664_Іванова/exam_jan_2025_3apndzwa.jpg',
    source: 'local',
  },
  {
    category: 'ext',
    type: 'SDC',
    author: '34244_Калюк',
    file: 'SDC/ext/34244_Калюк/exam_jan_2025_5cczvx7p.jpg',
    source: 'local',
  },
  {
    category: 'ext',
    type: 'SDC',
    author: '34257_ЯковлевДм',
    file: 'SDC/ext/34257_ЯковлевДм/exam_jan_2025_jb8sdo06.jpg',
    source: 'local',
  },
  {
    category: 'ext',
    type: 'SDC',
    author: '34294_Блажейко',
    file: 'SDC/ext/34294_Блажейко/exam_jan_2025_2ywmn1qu.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'SDC',
    author: '35497_Швець',
    file: 'SDC/int/35497_Швець/exam_jan_2025_v5toudz8.jpg',
    source: 'local',
  },
  {
    category: 'int',
    type: 'SDC',
    author: '35535_ПоліщукВ',
    file: 'SDC/int/35535_ПоліщукВ/exam_jan_2025_7kozbxha.jpg',
    source: 'local',
  },
]
